var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"delivery"},[_c('img',{attrs:{"src":require("../../assets/delivery/1.png"),"alt":""}}),_c('img',{attrs:{"src":require("../../assets/delivery/2.png"),"alt":""}}),_c('img',{attrs:{"src":require("../../assets/delivery/3.png"),"alt":""}}),_c('img',{attrs:{"src":require("../../assets/delivery/4.png"),"alt":""}})])
}]

export { render, staticRenderFns }